import {
  faCartShopping, faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import {
  type FC, type PropsWithChildren,
} from 'react';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons/roundButton/roundButton.component';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import { useTranslation } from '~/_shared/utils/hooks';
import type { BoundaryGroupPermissions } from '~/store/boundaryGroups/boundaryGroups.selectors';
import {
  actionsWrapperStyle,
  toolbarButtonStyle, toolbarButtonWrapperStyle,
} from './styles';

export type ActiveBoundaryTrialToolbarProps = Readonly<{
  boundaryPermissions: BoundaryGroupPermissions;
  onRemove: () => void;
  onPurchaseClick: () => void;
}>;

export const ActiveBoundaryOptimizedTrialToolbarComponent: FC<PropsWithChildren<ActiveBoundaryTrialToolbarProps>> = ({
  boundaryPermissions,
  onRemove,
  onPurchaseClick,
}) => {
  const [t] = useTranslation();
  const { boundaryIsCustom } = boundaryPermissions;

  return (
    <div css={actionsWrapperStyle}>
      <div css={toolbarButtonWrapperStyle}>
        <div css={toolbarButtonStyle}>
          <RoundButtonComponent
            icon={faCartShopping}
            onClick={onPurchaseClick}
            buttonStyle={RoundButtonStyle.ConfirmInverted}
            size={RoundButtonSize.Small}
            tooltipLabel={t('Upgrade Subscription')}
          />
        </div>

        <div css={toolbarButtonStyle}>
          <RoundButtonComponent
            icon={faXmark}
            onClick={onRemove}
            buttonStyle={RoundButtonStyle.Danger}
            size={RoundButtonSize.Small}
            tooltipLabel={
              t(boundaryIsCustom ?
                'Remove Territory Group from Map' :
                'Remove Boundary from Map')}
          />
        </div>
      </div>
    </div>
  );
};
